import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import {
  VENDOR_DIRECTORY_PERMISSIONS,
} from "../auth/casamapaVendorDirectoryPermissions";
import { resolveVendorDirectoryApiBase } from "../api/clientPortalFetch";

const PARTNER_VENDOR_DIRECTORY_PERMISSIONS = Object.values(VENDOR_DIRECTORY_PERMISSIONS);

export function useVendorDirectoryPermissions() {
  const { clientViewId } = useParams();
  const outlet = useOutletContext() || {};
  const [state, setState] = useState({
    loading: true,
    role: null,
    permissions: [],
    error: null,
  });

  useEffect(() => {
    if (outlet.partnerVendorDirectory) {
      setState({
        loading: false,
        role: "CASAMAPA_ADMINISTRATOR",
        permissions: PARTNER_VENDOR_DIRECTORY_PERMISSIONS,
        error: null,
      });
      return undefined;
    }

    let cancelled = false;
    async function load() {
      if (!clientViewId) {
        setState({ loading: false, role: null, permissions: [], error: null });
        return;
      }
      try {
        const res = await fetch(`${resolveVendorDirectoryApiBase(clientViewId)}/auth/me`, {
          credentials: "include",
        });
        if (!res.ok) {
          throw new Error("Failed to load vendor directory permissions");
        }
        const body = await res.json();
        if (!cancelled) {
          setState({
            loading: false,
            role: body.role || null,
            permissions: body.permissions || [],
            error: null,
          });
        }
      } catch (error) {
        if (!cancelled) {
          setState({
            loading: false,
            role: null,
            permissions: [],
            error: error.message || "Permission load failed",
          });
        }
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [clientViewId, outlet?.activeViewId, outlet?.partnerVendorDirectory]);

  return state;
}
